import { useEffect, useMemo, useState } from "react";
import Spinner from "../../Organization/components/Spinner";
import { Avatar, Button, Dropdown, Tabs, TabsProps, Tag } from "antd";
import ThreeDotsIcon from "../../../components/icons/ThreeDotsIcon";
import { useNavigate } from "react-router-dom";
import { avatarBg } from "../../../common/helpers";
import { STATUS_APPROVED, STATUS_NEW, TAB_ASSETS, TAB_INFO, TAB_SERVICE_SCOPE } from "../../../constants/constants";
import { Link } from "react-router-dom";
import LinkIcon from "../../../components/icons/LinkIcon";
import { getPartnerByID } from "../../../API/endpoints/Partner";
import PartnerAssets from "../../Partner/PartnerAssets";
import PartnerInfo from "../../Partner/PartnerInfo";
import DetailltemMore from "../../Organization/components/DetailltemMore";

interface Props {
    userProfile: any
}
const PartnerProfile = (props: Props) => {
    const { userProfile } = props

    const [details, setDetails] = useState<any>({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getPartnerByID(userProfile.partnerv2_id).then((res: any) => {
            setDetails(res?.data)
        }).catch((err) => {
            console.log("err", err);

        })
    }, [userProfile])

    const openLink = (link: string) => {
        if (link) {
            const fullUrl = link.startsWith("http") ? link : `https://${link}`;
            window.open(fullUrl, "_blank", "noopener,noreferrer");
        }
    }


    const items: TabsProps['items'] = useMemo(() => ([
        {
            key: TAB_INFO,
            label: 'Info',
            children: <PartnerInfo data={details} />,
        },
        {
            key: TAB_ASSETS,
            label: 'Assets',
            children: <PartnerAssets partnerProfile={details} />,
        },
    ]), [details]);

    return (
        <div className="h-[calc(100vh-49px)] p-[16px]">
            <div className='bg-white rounded-[8px] p-[16px] w-full grid grid-cols-7 mb-[6px]'>
                {loading ? (
                    <div className='w-full col-span-7 h-[90px]'>
                        <Spinner />
                    </div>

                ) : (
                    <>
                        <div className='col-span-2 flex gap-x-[12px] border-r border-[#E4E7EC] pr-[40px]'>
                            <Avatar style={{ backgroundColor: avatarBg(details?.name?.charAt(0)) }}>{details?.name?.charAt(0)}</Avatar>
                            <div>
                                <div className='flex items-center gap-x-[8px]'>
                                    <p className='m-0 text-[#1D2939] text-[14px] font-[500]'>{details?.name}</p>
                                    <Tag className='capitalize rounded-[12px] font-[500]' bordered={false} color={details?.status === STATUS_APPROVED ? 'success' : details?.status == STATUS_NEW ? 'blue' : 'warning'}>{details?.status?.replaceAll("_", " ")?.toLowerCase()}</Tag>
                                </div>
                                <p className='mt-[4px] text-[#475467] text-[12px] mb-[4px]'>{details?.region?.name}</p>
                                {details?.website ? (
                                    <div className='flex gap-x-[4px] items-center cursor-pointer' onClick={() => openLink(details?.website)}>
                                        <LinkIcon />
                                        <p className='max-w-[170px] truncate text-[12px] m-0 text-[#175CD3]'>{details?.website}</p>
                                    </div>
                                ) : (
                                    <></>
                                )}

                            </div>
                        </div>
                        <div className="col-span-2 border-r border-[#E4E7EC] pr-[40px]  ml-[40px] self-center">
                            <DetailltemMore label="Value Added Services" value={details?.value_added_services || []} length={2} />
                        </div>
                        <div className="col-span-3 ml-[40px] self-center">
                            <DetailltemMore label="Financial Assistance" value={details?.financial_assistance || []} length={2} />
                        </div>
                    </>

                )}

            </div>
            <Tabs defaultActiveKey={TAB_INFO} items={items} color='#12B76A' animated />
        </div>
    )
}

export default PartnerProfile